import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { LayoutGrid, MessageSquare, UserRound } from "lucide-react";

const TABS = [
    { key: "/accueil", label: "Accueil", Icon: LayoutGrid },
    { key: "/coach", label: "Coach", Icon: MessageSquare },
    { key: "/compte", label: "Compte", Icon: UserRound },
];

export const SubNav = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    return (
        <nav
            data-testid="sub-nav"
            className="shrink-0 border-t border-ink-700 bg-black safe-bottom flex items-stretch"
        >
            {TABS.map(({ key, label, Icon }) => {
                const active = pathname === key;
                return (
                    <button
                        key={key}
                        data-testid={`nav-${label.toLowerCase()}`}
                        onClick={() => navigate(key)}
                        className="tap-feedback flex-1 flex flex-col items-center justify-center gap-1 py-2.5"
                    >
                        <Icon size={22} className={active ? "text-revred" : "text-revtext-secondary"} />
                        <span className={`text-[11px] font-body ${active ? "text-white font-semibold" : "text-revtext-secondary"}`}>
                            {label}
                        </span>
                    </button>
                );
            })}
        </nav>
    );
};
